// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VT6d","right":"styles_right__1pH8k"};